import { RoleInternal } from "../../models/RoleInternal.interface";

type Roles = Record<string, RoleInternal>;

export const roles: Roles = {
    fullBasicAccess: {
        name: '${userId}$ApiKeyFullBasicAccess',
        description: 'ApiKey role with basic access on every team.',
        policies: [
            'fullLinkReadAccess',
            'fullBasicAccess',
        ],
    },
    teamBasicAccess: { // This role is legacy (before we used to attach apikey to a team)
        name: '${teamId}$ApiKeyTeamBasicAccess',
        description: 'ApiKey role with team basic access.',
        policies: [
            'teamLinkReadAccess',
            'teamBasicAccess',
        ],
    },
};
